export const currentRoom : {currentRoom: string} = {
    currentRoom: "",
};
